import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Modal,
  Button,
  Badge,
  Spinner,
} from "react-bootstrap";
import moment from "moment";
import TimePicker from "../../components/TimePicker/TimePicker";
//#region Slices
import { splitSlot } from "./../../Slices/candidateSlice";
import { showModal, showSpinner } from "./../../Slices/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import SpinnerButton from "../../components/SpinnerButton/SpinnerButton";
//#endregion

//#region CONSTANTS
export const id = "SPLIT_SLOT";
const splitSlotSaveId = "splitSlot.save";
//#endregion

function SplitSlot(props) {
  const { data } = props;

  const [splitTime, setSplitTime] = useState(null);
  const [warning, setWarning] = useState(null);

  const dispatch = useDispatch();
  const { spinner, selectedDay } = useSelector((state) => state.candidateSlice);
  const { sessionUser } = useSelector((state) => state.sessionSlice);

  const candidateId = sessionUser._id;
  //#region Validate Split Slot Time
  const validateInput = (time) => {
    if (time) {
      console.log("time", time, data.slotFrom, data.slotTo);
      if (!moment(time).isBetween(data.slotFrom, data.slotTo, "minutes")) {
        setWarning(" Time Should Be Between Slot From and To");
        setSplitTime(null);
      } else {
        setWarning(null);
        setSplitTime(time);
      }
    } else {
      setWarning(null);
      setSplitTime(null);
    }
  };
  //#endregion

  return (
    <Modal
      show={true}
      onHide={() => {
        dispatch(showModal(null));
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Split Session</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Row>
                <Col>
                  <h3>
                    <Badge bg="secondary">
                      {moment(data.slotFrom).format("h:mm A")}
                    </Badge>
                  </h3>
                </Col>
              </Row>
            </Col>
            <Col>
              <TimePicker
                getSelectedTime={(e) => validateInput(e)}
                label="to"
                date={moment(data.slotFrom).format("YYYY-MM-DD ")}
              />
            </Col>
            <Col>
              <h3>
                <Badge bg="secondary">
                  {moment(data.slotTo).format("h:mm A")}
                </Badge>
              </h3>
            </Col>
          </Row>
          <Row>
            {warning && (
              <div className="text-center mt-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  fill="red"
                  className="bi bi-exclamation-triangle"
                  viewBox="0 0 16 16"
                >
                  <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                  <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z" />
                </svg>
                <span className="">{warning}</span>
              </div>
            )}
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <SpinnerButton
          id={splitSlotSaveId}
          name="save"
          onClick={() => {
            dispatch(showSpinner({ id: splitSlotSaveId }));
            dispatch(
              splitSlot({
                splitTime,
                slotId: data.slotId,
                day: selectedDay,
              })
            );
          }}
          disabled={!splitTime}
          variant="primary"
        />
      </Modal.Footer>
    </Modal>
  );
}

export default SplitSlot;
